import React, { useCallback } from "react";
import InputSection from "./InputsSection";
import ResultsSection from "./ResultsSection";
import ChartsSection from "./ChartsSection";
import { UnitConverter } from "../../components/MeasurementUnits/UnitConverter";
import "./Hydrates.css";
import { useAppDispatch, useAppSelector } from "../../store/hooks/hooks";
import { setInputsData } from "../../store/slices/hydratesCalculatorSlice";

const converter = new UnitConverter();

const HydratesCalculator: React.FC = () => {
	const dispatch = useAppDispatch();
	const calculator = useAppSelector(state => state.hydratesCalculator);

	const handlePaste = useCallback(
		(event: React.ClipboardEvent<HTMLElement>) => {
			const clipboardText = event.clipboardData.getData("text");
			if (!clipboardText) {
				return;
			}

			const parsedValues = clipboardText
				.trim()
				.split(/\s+/)
				.map(token => Number.parseFloat(token.replace(",", ".")))
				.filter(value => Number.isFinite(value));

			if (parsedValues.length === 0) {
				return;
			}

			event.preventDefault();

			let startIndex = 0;
			const target = event.target;
			if (target instanceof HTMLInputElement) {
				const foundIndex = calculator.inputs.findIndex(
					input => input.id === target.id || input.queryName === target.name
				);
				if (foundIndex >= 0) {
					startIndex = foundIndex;
				}
			}

			dispatch(
				setInputsData({
					...calculator,
					inputs: calculator.inputs.map((input, index) => {
						const value = parsedValues[index - startIndex];
						if (value === undefined) {
							return input;
						}

						return {
							...input,
							currentValue: value,
							baseValue: input.unitCategoryId
								? converter.convert(value, input.currentUnitId, input.baseUnitId)
								: value,
							userValue: value,
							userUnitId: input.currentUnitId,
						};
					}),
				})
			);
		},
		[dispatch, calculator]
	);
	return (
		<div className="hydrates__container" onPasteCapture={handlePaste} tabIndex={0}>
			<InputSection
				converter={converter}
			/>
			<ResultsSection />
			<ChartsSection />
		</div>
	)
}

export default HydratesCalculator;
